import { Box, Button, Divider, Typography } from '@mui/material';
import React, { ErrorInfo } from 'react';
import logger from 'app/utils/logger';
import { btn, container, header, line, mainText, secondaryText } from './ErrorBoundary.sx';
import YeloLogo from 'app/components/Icons/YeloLogo';
import LargeAlertIcon from 'app/components/Icons/LargeAlertIcon';
import NavlinkWithTranslation from '../NavlinkWithTranslation';
interface ErrorBoundaryState {
  hasError: boolean;
}
export class ErrorBoundary extends React.Component<{ children?: any }, ErrorBoundaryState> {
  state = { hasError: false };
  search = window.location.pathname;
  lang = this.search.split('/')[1];

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.log('ERROR:', error);
    logger.log('ERROR INFO:', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={container}>
          <Box sx={line}></Box>
          <Box sx={header}>
            <NavlinkWithTranslation to="home-page">
              <YeloLogo />
            </NavlinkWithTranslation>
          </Box>
          <Divider sx={{ width: '100%' }} />
          <LargeAlertIcon sx={{ mt: '49px' }} />
          <Typography sx={mainText}>Xəta baş verdi!</Typography>
          <Typography sx={secondaryText}>Zəhmət olmasa, ana səhifəmizi ziyarət edin</Typography>
          <Button
            disableElevation={true}
            disableTouchRipple={true}
            variant={'contained'}
            onClick={() => (window.location.href = `/${this.lang}/home-page`)}
            sx={btn}
          >
            Ana səhifə
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}
